import type { ReactNode } from "react";

interface BadgeProps {
  tone?: "neutral" | "success" | "overdue" | "today" | "upcoming";
  children: ReactNode;
  className?: string;
}

export function Badge({ tone = "neutral", children, className = "" }: BadgeProps) {
  return <span className={`mmm-badge mmm-badge--${tone} ${className}`.trim()}>{children}</span>;
}
